export const SORT_OPERATOR_PREFIX = '__sort[';

export const isEmpty = obj => obj === ''
    || obj === null
    || obj === undefined
    || (obj.constructor === Object && Object.keys(obj).length === 0)
    || (obj.constructor === Array && obj.length === 0);

export const hasValue = obj => !isEmpty(obj);


export const mergePatchChanges = (data, changes) => (
    changes
        ? Object.keys(changes).reduce((prev, curr) => {
            if (curr.startsWith(SORT_OPERATOR_PREFIX)) {
                const arrayKeyMarker = curr.indexOf('[');
                const sortKeyEnd = curr.indexOf(']', arrayKeyMarker);
                const arrayName = curr.substring(arrayKeyMarker + 1, sortKeyEnd);
                const prevArray = prev[arrayName] || [];
                const orderLookup = changes[curr];

                return {
                    ...prev,
                    [arrayName]: prevArray.map(d => ({ ...d, sorting: orderLookup[d.id] })).sort((a, b) => a.sorting - b.sorting),
                };
            }

            const arrayKeyMarker = curr.indexOf('[');
            if (arrayKeyMarker > -1) {
                const arrayKeySeparator = curr.indexOf(':', arrayKeyMarker);
                const arrayKeyEnd = curr.indexOf(']', arrayKeySeparator);
                const arrayName = curr.substring(0, arrayKeyMarker);
                const arrayKey = curr.substring(arrayKeyMarker + 1, arrayKeySeparator);
                const arrayKeyValue = curr.substring(arrayKeySeparator + 1, arrayKeyEnd);
                const prevArray = prev[arrayName] || [];
                const index = prevArray.findIndex(d => d[arrayKey].toString() === arrayKeyValue);

                return {
                    ...prev,
                    [arrayName]: (index > -1
                        ? prevArray.map((e, i) => (i === index ? changes[curr] : e))
                        : [...prevArray, changes[curr]])
                        .filter(d => d),
                };
            }

            const objectDotIndex = curr.indexOf('.');
            if (objectDotIndex > -1) {
                const key = curr.substring(0, objectDotIndex);
                const subKey = curr.substring(objectDotIndex + 1);

                return {
                    ...prev,
                    [key]: {
                        ...prev[key],
                        [subKey]: changes[curr],
                    },
                };
            }

            return { ...prev, [curr]: changes[curr] };
        }, data || {})
        : data
);

export const mergePatchChangesInStore = (current, changes, update) => (
    {
        ...mergePatchChanges(current, changes),
        ...update,
    }
);

export const getValueByDotNotation = (obj, propName) => {
    if (!obj || !propName) { return null; }
    return propName.split('.').reduce((prev, curr) => (prev ? prev[curr] : null), obj);
};
